import { documentTypeUtils } from '@wix/santa-editor-utils';

export default {
  allowConnectToDB: true,
  supportedInCurrentDocument: () =>
    !documentTypeUtils.isCurrentDocumentTypeIsFluidDocument(),
};
